import React from 'react'
import StagesManager from './StagesManager';
import CredentialsType from '../windows/Developers/CredentialsType';
import CredentialsKey from '../windows/Developers/Credentialskey';
// import SelectQuery from './SelectQuery';
// import Recents from './Recents';
// import SelectName from './SelectName';
// import SelectNameSurvey from './SelectNameSurvey';
// import SelectNameExam from './SelectNameExam';
// import FormBuilderNew from './FormBuilderNew';
// import Reports from './Reports';
// import InquirySuccess from './InquirySuccess';
// import { getObject, imageAddress } from '../utils/useful';
// import Header from './header/Header';
// import { nanoid } from 'nanoid';
// import HttpServices from '../utils/Http.services';
// import DatabaseSettings from '../windows/Applets/database/SettingsSwitcher';


class CreateCredencial extends React.Component {
    state = {
        data: {}
    }

    changeValue = (value) => {
        let tempValue = value
        this.setState({ tempValue }, () => {
        })
    }


    componentDidMount() {

        let collectionId = this.props.windowData?.path[this.props.baseUrl?.length]
        this.setState({ collectionId }, () => [
        ])


        this.props.setHeader({
            'toolbar': null,
            'showToolbar': false,
            // topHeaderComponent: this.topHeaderComponent,
            // headerIdentityComponent: this.headerIdentityComponent,
            backAction: () => this.props.changePage('credentials')

        })


    }


    init() {
        this.setState({ data: {} }, () => {
            this.fetchData()
        })

    }



    setData = (key, value, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }


    render() {

        return (
            <div className='h-100 scroll-no-scrollbar'>

                <StagesManager ref={el => this.stageManager = el} fast={true}  >
                    <CredentialsType stage={0} stageName={'CredentialsType'} backStage={this.backStage} changePage={this.props.changePage} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} changeWindow={this.props.changeWindow} addNotif={this.props.addNotif} />
                    <CredentialsKey stage={1} stageName={'CredentialsKey'} backStage={this.backStage} changePage={this.props.changePage} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} changeWindow={this.props.changeWindow} />
                </StagesManager>
            </div>
        )
    }
}

export default CreateCredencial;